common.View.create('canvas.blocks.custom.themeSlider.Block', {

    onDOMLoad() {
        this.initSlider();
    },

    initSlider() {
        new Swiper(this.element.find('.items').get(0), {
            slidesPerView: 1,
            navigation: {
                nextEl: this.element.find('.swiper-button-next').get(0),
                prevEl: this.element.find('.swiper-button-prev').get(0),
            },
            breakpoints: {
                // when window width is >= 480px
                480: {
                    slidesPerView: 2,
                },
                // when window width is >= 768px
                768: {
                    slidesPerView: 3,
                },
                // when window width is >= 1024px
                1024: {
                    slidesPerView: 4,
                }
            },
            on: {
                init: (slider) => {
                    this.updateOpacity(slider);
                },
                slideChange: (slider) => {
                    this.updateOpacity(slider);
                },
            },
        });
    },

    updateOpacity(swiperInstance) {
        swiperInstance.slides.each( (slide, index) => {
            if (swiperInstance.isBeginning && index < 4) {
                slide.classList.add("swiper-slide-visible");
            } else if (
                index >= swiperInstance.activeIndex &&
                index < swiperInstance.activeIndex + 4
            ) {
                slide.classList.add("swiper-slide-visible");
            } else {
                slide.classList.remove("swiper-slide-visible");
            }
        });
    }
});
